import { Backdrop, Grid, List, ListItem } from '@material-ui/core';

import styled from 'styled-components';

import { getColorHeader, fontFamily } from '../../../../../../libs';

export const BackDropStyled = styled(Backdrop)`
  align-items: unset !important;
  z-index: 10 !important;
`;

export const CatContainer = styled.nav`
  position: relative;
  max-width: 1280px;
  width: 100%;
`;

export const SubContainer = styled(Grid)`
  position: absolute;
  background: #fff;
  padding: 5px;
  box-shadow: 0px 2px 2px 0px #00000040;
  border-radius: 0 0 5px 5px;
  z-index: 11;
  top: 100%;
`;

export const ListCategories = styled(List)`
  width: 100% !important;
  height: 100%;
  display: flex;
  padding: 0 !important;
  justify-content: center !important;
  overflow-x: auto !important;
  z-index: 12 !important;

  @media (max-width: 1280px) {
    transform: rotateX(180deg);
    -ms-transform: rotateX(180deg); /* IE 9 */
    -webkit-transform: rotateX(180deg); /* Safari and Chrome */

    & li {
      -ms-transform: rotateX(180deg); /* IE 9 */
      -webkit-transform: rotateX(180deg); /* Safari and Chrome */
    }
    * {
      font-size: 13px !important;
    }
  }

  &::-webkit-scrollbar {
    width: 10px;
    height: 6px;
    position: absolute;
  }

  &::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px #00000040 !important;
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb {
    background: #c9c9c9;
    border-radius: 10px;
  }
`;

export const ListItemCategorie = styled(ListItem)`
  font-family: ${fontFamily} !important;
  font-weight: bold !important;
  text-shadow: ${({ iscurrent }) => (iscurrent ? 'none' : '0.5px 0.5px 3px #00000040')};
  justify-content: center !important;
  border-radius: 5px 5px 0 0;
  font-size: 13px;
  padding: 0 !important;
  /* flex: 1 !important; */
  width: fit-content !important;
  z-index: 11 !important;
  background: ${({ iscurrent, background }) => (iscurrent ? '#fff' : background || 'inherit')} !important;
  color: ${({ fontcolor, iscurrent, background, theme }) =>
    iscurrent ? background || theme.colors.header : fontcolor || '#fff'} !important;
`;

export const ListSubCategories = styled(List)`
  padding: 0 10px 10px 10px !important;
  width: 100% !important;
`;

export const ListItemSubCategorie = styled(ListItem)`
  padding: 0 !important;
  font-size: 13px;
  color: ${({ background }) => background || 'inherit'} !important;
  color: ${({ fontcolor }) => fontcolor || '#333'} !important;
`;

export const StyledLink = styled.a`
  padding: 3px 0;
  text-align: ${({ textalign }) => textalign || 'left'};
  width: 100%;
  height: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;

  &:hover {
    text-decoration: underline;
  }
`;

export const LinkCategories = styled(StyledLink)`
  padding: 10px;

  &:hover {
    text-decoration: none;
  }
`;

export const ListTitle = styled.p`
  width: 100%;
  height: 25px;
  margin: 0;
  display: flex;
  padding: 0px 10px;
  overflow: hidden;
  font-weight: bold;
  color: ${getColorHeader};
  font-size: 13px;
`;

export default {};
